import { defineMessages } from 'react-intl'

export default defineMessages({
    fineAlreadyCancelledError: {
        defaultMessage: 'La denuncia ya ha sido anulada',
    },
    fineOutOfDatesError: {
        defaultMessage: 'La denuncia ya no se puede anular, está fuera de plazo',
    },
    fineNonCancellableError: {
        defaultMessage: 'La denuncia no se puede anular',
    },
    unknownError: {
        defaultMessage: 'Ha ocurrido un error procesando su solicitud',
    },
})
